import React, {useEffect, useState} from 'react';
import {
    SHOPIFY_BULK_PRODUCT_UPDATE_FIELDS_LIST
} from "../../constants/shopify.constant";
import _ from "lodash";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    getShopifyProductsSyncStatus, getShopifyProductUpdatesStatus,
    initiateShopifyBulkProductUpdates,
    syncShopifyProducts
} from "../../../common/services/cloud-function-service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {
    searchShopifyBulkProductUpdates,
    deleteShopifyBulkProductUpdates
} from "../../services/shopify-bulk-product-update-data-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const ShopifyBulkProductUpdateList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [bulkProductUpdatesList, setBulkProductUpdatesList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    useEffect(() => {
        if (initialStep) {
            getShopifyBulkProductUpdateList();
            setInitialStep(false);
        }
    }, [initialStep]);

    const getShopifyBulkProductUpdateList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [
            /*{
                field: 'status',
                condition: '==',
                value: 'CREATED'
            },*/
        ];
        const bulkProductUpdateListResult = await searchShopifyBulkProductUpdates(searchCriteriaList, 100);
        // await deleteShopifyBulkProductUpdates(bulkProductUpdateListResult);

        bulkProductUpdateListResult?.forEach((bulkProductUpdate) => {
            if (_.isObject(bulkProductUpdate.createdAt)) {
                bulkProductUpdate.createdAt = new Date(bulkProductUpdate.createdAt.seconds * 1000).toLocaleString();
            }
        });

        // console.log('bulkProductUpdateListResult', bulkProductUpdateListResult);

        setBulkProductUpdatesList(_.orderBy(bulkProductUpdateListResult, ['updatedAt'], ['desc']));
        setDataFetchInProgress(false);
    }

    const startBulkProductUpdateSyncProcess = async (bulkProductUpdateId) => {
        setDataFetchInProgress(true);
        const response = await initiateShopifyBulkProductUpdates(bulkProductUpdateId);

        await getShopifyBulkProductUpdateList();
        setDataFetchInProgress(false);
    }

    const getLatestBulkProductUpdateStatus = async () => {
        setDataFetchInProgress(true);
        const response = await getShopifyProductUpdatesStatus();

        await getShopifyBulkProductUpdateList();
        setDataFetchInProgress(false);
    }

    const refreshShopifyBulkProductUpdateList = async () => {
        await getShopifyBulkProductUpdateList();
    }

    return (
        <>
            <div className="flex justify-start">
                <div className="w-full mt-2 flex justify-between">

                    <div className="flex items-center text-lg font-bold text-gray-500">
                        Shopify Bulk Product Updates
                    </div>

                    <div className="mr-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>


                    <div className="flex justify-end">
                        <div className="">
                            <button
                                className="button-green-outline px-4 py-2 flex items-center justify-center"
                                onClick={refreshShopifyBulkProductUpdateList}>
                                <span>Refresh</span>
                                <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                            </button>
                        </div>

                        <div className="ml-2">
                            <button
                                className="button-gray px-4 py-2 flex items-center justify-center"
                                onClick={getLatestBulkProductUpdateStatus}>
                                <span>Get Latest Bulk Product Update Status</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-bulk-operation-table-container w-full mt-4  overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={bulkProductUpdatesList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Bulk Product Updates'}/>

                    {bulkProductUpdatesList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_BULK_PRODUCT_UPDATE_FIELDS_LIST?.map((bulkProductUpdateField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{bulkProductUpdateField?.label}</th>
                                ))}

                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Action</th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {bulkProductUpdatesList?.map((bulkProductUpdate, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_BULK_PRODUCT_UPDATE_FIELDS_LIST?.map((bulkProductUpdateField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto text-center">

                                                {bulkProductUpdate[bulkProductUpdateField?.attribute] &&
                                                    <>{bulkProductUpdate[bulkProductUpdateField?.attribute]}</>
                                                }

                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="w-fit p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center items-center">
                                            {bulkProductUpdate?.status === 'NEW' &&
                                                <div className="">
                                                    <button
                                                        className="button-green px-3 py-1 flex items-center justify-center"
                                                        onClick={() => {
                                                            startBulkProductUpdateSyncProcess(bulkProductUpdate.id)
                                                        }}>
                                                        <span>Start Bulk Update Process</span>
                                                    </button>
                                                </div>
                                            }

                                            <CopyDataToClipboard value={JSON.stringify(bulkProductUpdate, null, 2)}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyBulkProductUpdateList
